import { MessageSenderType } from '@app/domain/BookingCommunicationMessage'

export class MessageThread {
    constructor(
        public bookingId: string,
        public customerName: string,
        public customerEmail: string | null,
        public bookingDate: Date,
        public partySize: number,
        public lastMessageBody: string,
        public lastMessageSenderType: MessageSenderType,
        public lastMessageDate: Date,
        public messageCount: number,
        public unreadMessageCount: number,
        public lastCustomerMessageReadAt: Date | null,
    ) { }

    get lastMessagePreview(): string {
        const maxLength = 80
        if (this.lastMessageBody.length <= maxLength) {
            return this.lastMessageBody
        }
        return this.lastMessageBody.substring(0, maxLength) + '...'
    }

    get lastMessageWasMerchant(): boolean {
        return this.lastMessageSenderType === 'MERCHANT'
    }

    get hasUnreadMessages(): boolean {
        return this.unreadMessageCount > 0
    }
}
